export default __webpack_public_path__ + "static/blog-thumb-1-ad38ae60a0aa9aae6661e4df0c8d97ad.webp";